import { mapGetters } from "vuex";

export const contract_form = {
  data() {
    var validateZipcode = (rule, value, callback) => {
      if (["1", "2", "4", "11", "12"].includes(this.data.delivery_way_flag)) {
        if (!value) {
          callback(new Error("우편번호를 입력해 주세요."));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // var validateValidDate = (rule, value, callback) => {
    //   if (!value || !this.data.contract_date) {
    //     callback();
    //     return;
    //   }
    //   if (value < this.data.contract_date) {
    //     callback(new Error("수주일보다 빠릅니다."));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      title: this.$t("title.contract_reg"),
      sum: 0,
      form_data: undefined,
      customer: undefined,
      rules: {
        customer_id: [{ required: true, message: "거래처를 선택해 주세요." }],
        zipcode: [{ validator: validateZipcode }],
        contract_date: [{ required: true, message: "수주일을 선택해 주세요." }],
        delivery_date: [
          { required: true, message: "납기일을 선택해 주세요." },
          // { validator: validateValidDate, trigger: ["blur", "change"] }
        ],
        delivery_way_flag: [
          { required: true, message: "출하방법을 선택해 주세요." },
        ],
      },
      balance: 0,
      skip_past_contract_by_today: false,
      skip_past_delivery_by_contract: false,
      skip_fast_sale_by_contract: false,
    };
  },
  computed: {
    ...mapGetters(["table_customer"]),
    isNew() {
      return this.data.id < 1;
    },
    isProduction() {
      if (this.isNew) {
        return false;
      }
      let item = this.data.details.find((d) => d.production_flag !== "0");
      return !!item;
    },
    isSale() {
      if (this.isNew) {
        return false;
      }
      let item = this.data.details.find((d) => d.status_flag !== "0");
      return !!item;
    },
    isService() {
      return !this.data.service_id;
    },
    disabled() {
      return !this.customer;
    },
    invalid_details() {
      let invalid_index = [];
      this.getDetails().forEach((d) => {
        if (d.product_name && !d.product_id && !d.option_id) {
          return invalid_index.push(d.seq);
        }
      });
      return invalid_index;
    },
    customerDesc() {
      return this.customer ? this.customer.desc : "";
    },
  },
  methods: {
    initData() {
      return {
        id: 0,
        code: "",
        delivery_way_flag: null,
        customer_id: 0,
        customer_name: "",
        customer_tel: "",
        zipcode: "",
        contract_date: this.util.getDate(0),
        delivery_date: this.util.getDate(1),
        sale_date: null,
        destination: "",
        direct_sale_flag: "N",
        emergency_flag: "N",
        price: 0,
        tel: "",
        total_price: 0,
        desc: "",
        details: [],
        status_flag: "0",
        org_customer_id: 0,
      };
    },
    resetData() {
      let oldData = this.util.clone(this.data);
      this.data = this.initData();
      this.data.customer_id = oldData.customer_id;
      this.data.customer_name = oldData.customer_name;
      this.data.customer_tel = oldData.customer_tel;
      this.data.zipcode = oldData.zipcode;
      this.data.destination = oldData.destination;
    },
    getDetails(getPerAmount = false) {
      const trades = this.$refs.trade.result();
      const details = [];
      //let product_name = '';
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_id && !trades[i].amount) {
          continue;
        }
        let detail = Object.assign({}, trades[i]);
        if (!detail.cost) {
          detail.cost = 0;
        }
        if (!detail.supply_price) {
          detail.supply_price = 0;
        }
        if (!detail.tax) {
          detail.tax = 0;
        }
        if (!detail.price) {
          detail.price = 0;
        }
        if (!detail.specification || detail.specification.length < 1) {
          detail.specification = null;
        }
        if (getPerAmount) {
          if (detail.specification) {
            let machine_amount = 0;
            detail.specification.forEach((s) => {
              let machine_detail = details.find((d) => d.seq === s);
              if (machine_detail) {
                machine_amount += Number.parseFloat(machine_detail.amount);
              }
            });
            detail.per_amount = detail.amount / machine_amount;
          } else {
            detail.per_amount = detail.amount;
          }
        }
        if (!detail.delivery_date) {
          detail.delivery_date = this.data.delivery_date;
        }
        if (!detail.delivery_way_flag) {
          detail.delivery_way_flag = this.data.delivery_way_flag;
        }
        if (!detail.zipcode) {
          detail.zipcode = this.data.zipcode;
        }
        if (!detail.destination) {
          detail.destination = this.data.destination;
        }
        if (!detail.charger) {
          detail.charger = this.data.charger;
        }
        if (!detail.schedule_flag) {
          detail.schedule_flag = this.data.schedule_flag;
        }
        // detail.seq = i + 1;
        details.push(detail);
      }
      return details;
    },
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        /**
         * ERP-422 수주 등록 페이지 거래처 변경 처리
         * 위의 이슈 처리로 인해 아래의 코드 주석 처리
         */
        // this.data.customer_id = null;
        // this.data.customer_name = c;
        // if (this.isNew) {
        //   this.data.details = [];
        // }
        // if (!this.data.service_id) {
        //   this.data.customer_tel = "";
        //   this.data.zipcode = "";
        //   this.data.destination = "";
        // }
        // this.customer = null;
        // this.balance = 0;
      } else {
        /**
         * ERP-422 수주 등록 페이지 거래처 변경 처리
         * 거래처 변경에 대한 이벤트 발생
         */
        if (
          this.data.org_customer_id !== 0 &&
          this.data.org_customer_id !== c.id
        ) {
          this.EventBus.$emit("changeCustomer", c);
        } else {
          this.data.customer_id = c.id;
          this.data.customer_name = c.name;
          this.customer_desc = c.desc;
          if (!this.data.service_id) {
            this.data.customer_tel = c.tel;
            this.data.zipcode = this.util.getCustomerZipcode(c);
            this.data.destination = this.util.getCustomerAddress(c);
          }
          this.customer = c;
          this.api.selectIncomeCustomer(this.customer.id).then((res) => {
            if (res.error !== this.system.noError) {
              return;
            }
            this.balance = res.data ? res.data.balance : 0;
            if (this.customer.credit_line && this.balance) {
              if (this.customer.credit_line < this.balance) {
                this.util.notify_warning(
                  this,
                  this.title,
                  "여신한도를 초과한 업체입니다."
                );
              }
            }
          });
          this.data.org_customer_id = c.id;
        }
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickRegister() {
      if (!this.has_grant_write) {
        return;
      }
      if (this.isSale || this.disabled) {
        return;
      }
      this.skip_past_contract_by_today = false;
      this.skip_past_delivery_by_contract = false;
      this.skip_fast_sale_by_contract = false;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$alert("필수 입력 항목이 비어있습니다.", this.title, {
            type: "warning",
          });
          // this.util.notify_warning(
          //   this,
          //   this.title,
          //   "필수 입력 항목이 비어있습니다."
          // );
          return;
        }
        let details = this.getDetails();
        if (details.length < 1) {
          this.util.notify_warning(this, this.title, "내역을 입력해 주세요.");
          return;
        }
        if (this.invalid_details.length > 0) {
          this.util.notify_warning(
            this,
            this.title,
            this.invalid_details +
              "번째 품명을 올바르게 선택하지 않으셨습니다. 다시 선택하여 주시기 바랍니다."
          );
          return;
        }
        let isExistSpecification = true;
        let isMachineNoSpecification = true;
        let isAvailSpecificationAmount = true;
        let machine_amount = 0;
        details.forEach((d) => {
          if (!d.specification) {
            return true;
          }
          machine_amount = 0;
          d.specification.forEach((s) => {
            let machine_spec = details.find((d2) => d2.seq === s);
            if (!machine_spec) {
              //사양 항목에 품목이 입력되어 있는지
              isExistSpecification = false;
            } else if (
              machine_spec.specification &&
              machine_spec.specification.length > 0
            ) {
              //사양 항목이 또 다른 사양이 아닌지
              isMachineNoSpecification = false;
            } else {
              machine_amount += Number.parseFloat(machine_spec.amount);
            }
          });
          if (isExistSpecification && isMachineNoSpecification) {
            //현재 수량이 사양 합계의 배수인지 확인
            if (d.amount % machine_amount !== 0) {
              isAvailSpecificationAmount = false;
            }
          }
        });
        if (!isExistSpecification) {
          this.util.notify_warning(this, this.title, "사양이 비어 있습니다.");
          return;
        }
        if (!isMachineNoSpecification) {
          this.util.notify_warning(
            this,
            this.title,
            "사양이 올바르게 선택되지 않았습니다."
          );
          return;
        }
        if (!isAvailSpecificationAmount) {
          this.util.notify_warning(
            this,
            this.title,
            "사양 수량이 올바르지 않습니다."
          );
          return;
        }
        this.validAdditional();
      });
    },
    validAdditional() {
      if (!this.skip_past_contract_by_today) {
        if (this.isNew && this.util.isPastDate(this.data.contract_date)) {
          this.util.confirm(
            this,
            this.title,
            "수주일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.approvePastContractByToday
          );
          return;
        }
      }
      if (!this.skip_past_delivery_by_contract) {
        if (this.isNew && this.data.delivery_date < this.data.contract_date) {
          this.util.confirm(
            this,
            this.title,
            "납기일이 수주일보다 늦습니다. 계속 등록하시겠습니까?",
            this.approvePastDeliveryByContract
          );
          return;
        }
      }
      if (!this.skip_fast_sale_by_contract) {
        if (this.isNew && this.data.sale_date < this.data.contract_date) {
          this.util.confirm(
            this,
            this.title,
            "매출일이 수주일보다 빠릅니다. 계속 등록하시겠습니까?",
            this.approveFastSaleByContract
          );
          return;
        }
      }
      if (this.isNew && this.customer.credit_line && this.balance) {
        if (this.customer.credit_line < this.balance + this.sum) {
          this.util.confirm(
            this,
            this.title,
            "여신한도를 초과하였습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
      }
      this.doRegister();
    },
    approvePastContractByToday() {
      this.skip_past_contract_by_today = true;
      this.validAdditional();
    },
    approvePastDeliveryByContract() {
      this.skip_past_delivery_by_contract = true;
      this.validAdditional();
    },
    approveFastSaleByContract() {
      this.skip_fast_sale_by_contract = true;
      this.validAdditional();
    },
    handleCompleteZipcode(zipcode, addr) {
      this.data.zipcode = zipcode;
      this.data.destination = addr + " ";
      this.$refs.destination.focus();
    },
    handleChangeDeliveryWay() {
      let info = this.util.getAddressByDeliveryWay(
        this.data.delivery_way_flag,
        this.customer
      );
      if (!info) {
        return;
      }
      this.data.zipcode = info.zipcode;
      this.data.destination = info.addr;
    },
    handleUpdated() {
      this.$emit("updated");
    },
  },
};
